import styled from '@emotion/styled'

import type { ButtonModifier } from '@polycups/react'

import { BodyM, HeadingM, HeadingS } from '@/components/Typography'

import { withContainer } from '@/hocs/withContainer'
import type { TitleProps } from '@/models'
import { CONFIG } from '@/styles/emotion.config'

import { LIST_SIZE } from '../constants'

import LoanCta from './LoanCta'
import { LoanSimulatorProvider } from './LoanSimulatorProvider'
import Simulator from './Simulator'

const LoanSimulatorStyles = styled.div`
  .cta {
    margin-top: 1.875rem;
    width: 17.5rem;
  }

  ${CONFIG.media.mobileLg} {
    .cta {
      display: flex;
      width: 100%;
    }
  }
`
interface Props {
  title?: TitleProps
  subtitle?: TitleProps
  size: 'm' | 'l'
  cta: {
    modifier?: ButtonModifier
    label: string
    rounded?: boolean
  }
  hasCta?: boolean
}

const LoanSimulatorBlock = ({ title, subtitle, size, hasCta, cta }: Props) => {
  const TitleComponent = size === LIST_SIZE.lg ? HeadingM : HeadingS

  return (
    <LoanSimulatorStyles>
      {title && title.text && (
        <TitleComponent className="eu-sm-1" tag={title.tag || 'h3'}>
          {title.text}
        </TitleComponent>
      )}
      {subtitle && subtitle.text && (
        <BodyM className="eu-sm-2" tag={subtitle.tag || 'p'}>
          {subtitle.text}
        </BodyM>
      )}
      <LoanSimulatorProvider>
        <Simulator />
        {hasCta && <LoanCta {...cta} />}
      </LoanSimulatorProvider>
    </LoanSimulatorStyles>
  )
}

export default withContainer(LoanSimulatorBlock, {
  spaceOut: 'm',
  className: 'eu-sp-m',
  maxWidth: 'md',
  spaceIn: 's',
})
